var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSandboxFooterLogo = function SvgSandboxFooterLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#646464",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.577 5.684 17.366 9.671v2.574c0 .166-.092.32-.242.403l-4.02 2.24v-2.316L0 8.409V6.246c0-.166.092-.32.241-.403l4.336-2.414zM0 11.657v5.706c0 .175.09.337.238.424l10.334 6.147a.46.46 0 0 0 .476 0l4.723-2.81zM11.127.06a.48.48 0 0 1 .466 0L21.71 5.723c.144.081.233.23.233.391v4.857L6.857 2.451z"
  }))));
};
export default SvgSandboxFooterLogo;